module.exports = __webpack_public_path__ + "static/ph-87ea5320de70bfa80783d04053001b5c.png";